var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCampaignLockedCircular = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -23.5294,
    y: -23.5294,
    width: 147.059,
    height: 147.059
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(11.76px)",
      clipPath: "url(#bgblur_0_23093_31350_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 23.5294,
    cx: 50,
    cy: 50,
    r: 49.4118,
    fill: "#F0F5FF",
    fillOpacity: 0.05,
    stroke: "url(#paint0_linear_23093_31350)",
    strokeWidth: 1.17647
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.0737,
    cy: 50.0742,
    r: 31.25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0057 45.4159V42.161C54.0057 39.7032 52.2033 37.6922 50.0002 37.6922C47.7971 37.6922 45.9947 39.7031 45.9947 42.161V45.4159H42.7903V42.1611C42.7903 37.737 46.0348 34.1172 50.0002 34.1172C53.9657 34.1172 57.2101 37.737 57.2101 42.1611V45.4159H54.0057ZM61.1767 49.8918V63.6105C61.1767 65.1474 60.0496 66.4048 58.6722 66.4048H41.3283C39.9508 66.4048 38.8237 65.1474 38.8237 63.6105V49.8917C38.8237 48.3549 39.9508 47.0975 41.3283 47.0975H58.6722C60.0496 47.0975 61.1767 48.3549 61.1767 49.8918ZM52.1064 54.6065C52.1064 53.3087 51.1635 52.2566 50.0002 52.2566C48.8369 52.2566 47.894 53.3087 47.894 54.6065C47.894 55.405 48.2511 56.1103 48.7967 56.535V59.9031C48.7967 60.6416 49.3382 61.2458 50.0002 61.2458C50.6622 61.2458 51.2037 60.6416 51.2037 59.9031V56.5349C51.7494 56.1103 52.1064 55.4049 52.1064 54.6065Z",
    fill: "#6B7DE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_23093_31350_clip_path",
    transform: "translate(23.5294 23.5294)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.4118
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23093_31350",
    x1: 29.3269,
    y1: 5.17325e-7,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EACFA"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCampaignLockedCircular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/campaign_locked_circular.d5a0e2f86bc806da0f90f994594d27a7.svg";